import auth from "../../middlewares/auth";
export const promotionSettingsRoute = [
  {
    path: '/settings/promotion',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/promotion/PromotionList'),
    name: 'settings_promotion',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/promotion/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/promotion/PromotionForm'),
    name: 'settings_promotion_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/promotion/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/promotion/PromotionForm'),
    name: 'settings_promotion_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];